// pdp-shoppay-sale.js — Next Diamonds
// Makes the Shop Pay "as low as $X/mo" monthly reflect the ACTIVE SALE price
// (the amount actually charged at checkout), not the pre-sale retail price.
//
// Shopify's <shopify-payment-terms> computes its installment math from a
// `shopify-meta` JSON attribute (full_price + price_per_term per variant).
// That JSON carries the RETAIL price and is blind to our storefront discount,
// so the monthly reads high. We patch the JSON in place, same technique the
// carat selector already uses on ring/bridal pages.
//
// SCOPE: pages WITHOUT a carat selector (wedding bands, plain rings, etc.).
// On carat pages, pdp-carat-selector.js owns <shopify-payment-terms> and
// already applies the discount — so we BAIL there to avoid double-discounting.
(function () {
  'use strict';

  var promo = window.ndPromo || {};
  var pct = parseFloat(promo.discountPercent);
  if (isNaN(pct) || pct <= 0 || pct >= 100) return; // no active sale → nothing to do

  // Carat selector owns Shop Pay on its pages. Don't touch it here.
  if (document.querySelector('.nd-carat__pill')) return;

  var factor = 1 - pct / 100;

  function moneyToCents(s) {
    if (s == null) return null;
    // "$7,200.00" → 720000. Strip everything except digits and the decimal dot.
    var n = parseFloat(String(s).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }
  function fmtMoney(cents) {
    return '$' + (Math.round(cents) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  var obs;
  function termsEls() { return document.querySelectorAll('shopify-payment-terms'); }
  function observeAll() {
    if (!obs) return;
    termsEls().forEach(function (sp) {
      obs.observe(sp, { attributes: true, attributeFilter: ['shopify-meta', 'variant-id'] });
    });
  }

  function apply(sp) {
    var raw = sp.getAttribute('shopify-meta');
    if (!raw) return;
    // Idempotent guard: if this is the exact JSON we last wrote, it's already
    // discounted — skip. A genuine Shopify re-render (variant change) writes
    // fresh RETAIL meta that won't match, so those still get re-applied.
    if (sp.__ndSaleOut === raw) return;

    var meta;
    try { meta = JSON.parse(raw); } catch (e) { return; }
    if (!meta || !Array.isArray(meta.variants)) return;

    var changed = false;
    meta.variants.forEach(function (v) {
      var cents = moneyToCents(v.full_price);
      if (cents == null) return;
      var dc = Math.round(cents * factor);
      v.full_price = fmtMoney(dc);
      if (v.number_of_payment_terms) {
        v.price_per_term = fmtMoney(dc / v.number_of_payment_terms);
      }
      changed = true;
    });
    if (!changed) return;

    var out = JSON.stringify(meta);
    if (obs) obs.disconnect();
    sp.setAttribute('shopify-meta', out);
    sp.__ndSaleOut = out;                 // remember our output → idempotency
    var vid = sp.getAttribute('variant-id'); // nudge re-render
    if (vid) sp.setAttribute('variant-id', vid);
    if (obs) observeAll();
  }

  function applyAll() { termsEls().forEach(apply); }

  function init() {
    obs = new MutationObserver(function (muts) {
      var seen = [];
      muts.forEach(function (m) {
        var t = m.target;
        if (t && seen.indexOf(t) === -1) { seen.push(t); apply(t); }
      });
    });
    applyAll();
    observeAll();
    // <shopify-payment-terms> hydrates late; re-apply on a few beats.
    [300, 900, 1800, 3000].forEach(function (t) { setTimeout(applyAll, t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
